// Survey View
// Handles customer satisfaction survey

import { submitSurvey } from '../services/queue-service.js';
import { validateRating } from '../utils/validators.js';
import stateManager from '../core/state-manager.js';

/**
 * Initialize survey form
 */
export function initSurveyForm() {
    const form = document.getElementById('survey-form');
    const ratingButtons = document.querySelectorAll('.rating-btn');

    // Rating button handlers
    ratingButtons.forEach(button => {
        button.addEventListener('click', () => {
            const rating = button.dataset.rating;
            document.getElementById('rating').value = rating;

            // Visual feedback - scale selected button
            ratingButtons.forEach(btn => btn.style.transform = 'scale(1)');
            button.style.transform = 'scale(1.3)';
        });
    });

    // Form submission
    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const currentCustomerId = stateManager.getState('currentCustomerId');

        if (!currentCustomerId) {
            alert('No se encontró tu información. Por favor, intenta nuevamente.');
            return;
        }

        const rating = form.rating.value;

        if (!validateRating(rating)) {
            alert('Por favor, selecciona una calificación.');
            return;
        }

        const comments = form.comments.value || '';

        try {
            await submitSurvey(currentCustomerId, rating, comments);

            // Hide form and show thank you message
            form.classList.add('hidden');
            document.getElementById('thank-you-message').classList.remove('hidden');

            // Clear customer ID after 5 seconds
            setTimeout(() => {
                stateManager.clearCurrentCustomerId();
            }, 5000);
        } catch (error) {
            console.error("Error submitting survey:", error);
            alert('Hubo un error al enviar tu encuesta. Por favor, intenta nuevamente.');
        }
    });
}
